import { IntlShape } from 'react-intl'
import { LIMITS } from 'shared'
import { create, enforce, test } from 'vest'
import { messages } from '../messages'
import { filterValidEntries } from './utils'

export function validationSuite(
  intl: IntlShape,
  filledEntries: number,
  maxEntries = LIMITS.MAX_BINS
) {
  return create((entries: string[]) => {
    const { formatMessage: i18n } = intl
    const { validation } = messages.fileInput
    const validEntries = filterValidEntries(entries)
    const wrongCount = entries.length - validEntries.length
    test('entries', i18n(validation.allInvalidEntries), () => {
      enforce(validEntries).isNotEmpty()
    })
    test(
      'entries',
      i18n(validation.invalidEntries, { count: wrongCount }),
      () => {
        enforce(wrongCount).equals(0)
      }
    )
    test('entries', i18n(validation.maxSize, { count: maxEntries }), () => {
      enforce(entries.length).lte(maxEntries - filledEntries)
    })
  })
}
